export class ItemMenu {
  title?: string;
  routerLink?: string;
  outgoingLink?: string;

  constructor(title?: string, routerLink?: string, outgoingLink?: string) {
    this.title = title;
    this.routerLink = routerLink;
    this.outgoingLink = outgoingLink;
  }
}
